/** The two SWMS libraries, matching the two folders in the Safety Library. */
export type SwmsType = 'Building' | 'Painting';

export const SWMS_TYPES: readonly SwmsType[] = ['Building', 'Painting'] as const;

/** Split a comma/semicolon separated address list into trimmed, non-empty parts. */
export function parseEmailList(raw: string): string[] {
  return raw
    .split(/[,;]/)
    .map((part) => part.trim())
    .filter(Boolean);
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** The addresses in `raw` that are not plausible email addresses. */
export function invalidEmails(raw: string): string[] {
  return parseEmailList(raw).filter((address) => !EMAIL_PATTERN.test(address));
}
